import React from "react";
import axios from "axios";
import {
    message
} from "antd";
import {
    getToken,
    getBaseAuthRequestUrl,
    getBaseRequestUrl,
} from "./constants";

const showError = (msg) => {
    message.error(msg);
};
const http = axios.create({
    baseURL: getBaseRequestUrl()
});

http.interceptors.request.use(config => {
    const token = getToken();
    if (token) {
        config.headers.authorization = token;
        if (config.url) {
            config.baseURL = config.url.indexOf("/portal/") !== -1 ? getBaseAuthRequestUrl() :
                getBaseRequestUrl();
        }
    }
    return config;
}, error => Promise.reject(error));
http.interceptors.response.use(res => {
    if (res.data && res.data.retCode && res.data.retCode === 200) {
        return res.data.retData;
    } else if (res.data && res.data.retCode && Number(res.data.retCode) === 999) {
        showError("Token过期，请退出系统，重新登陆！");
        return Promise.reject(res.data);
    } else if (res.data && res.data.retCode && Number(res.data.retCode) === 500) {
        showError(res.data.retMsg);
        return Promise.reject(res.data);
    } else {
        showError("请求错误:" + res.data.retCode + ":::" + res.data.retMsg);
        return Promise.reject(res.data);
    }

},
    error => {
        //console.log(error)
        if (!!error.response &&
            !!error.response.status &&
            error.response.status === 500 &&
            !!error.response.data &&
            !!error.response.data.retCode &&
            error.response.data.retCode !== 500) {
            showError("请求错误:" + error.response.data.retCode + ":::" + error.response.data.retMsg);
            return Promise.reject(error.response.data);
        } else {
            showError(error.response.data.retMsg);
            // return Promise.reject(error);
        }

    });
export default http;

export const download = (url, resOpts = {}, time = 15) => {
    console.log(resOpts)
    const {
        type = "get", data = {}, params = {}
    } = resOpts;
    const token = getToken();
    const queryArgs = {
        url,
        baseURL: getBaseRequestUrl(),
        method: type,
        headers: {
            // Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            // withCredentials: true,
            authorization: token
        },
        responseType: "blob",
        timeout: 1000 * time,
    }
    if (type.toLowerCase() === 'get') {
        queryArgs["params"] = params;
    } else {
        queryArgs["data"] = data;
    }
    return axios.request(queryArgs)
        .then(res => {
            convertRes2Blob(res)
        })
        .catch(err => { });
}

function convertRes2Blob(response) {
    try {


        // debugger;
        /*let fname = response.headers['content-disposition'].split('\'\'')[1];
        if (fname) {
            fname = decodeURI(fname);
        }
        console.log(decodeURI(fname));*/
        // 提取文件名
        // const fileName = response.headers['content-disposition'].match(
        //     /filename\*=UTF-8''(.*)/
        // )[1];
        const fileName = response.headers['content-disposition'].match(
            /filename=(.*)/
        )[1]
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
            type: 'application/octet-stream'
        })
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
            window.navigator.msSaveBlob(blob, decodeURI(fileName))
        } else {
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(fileName))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        }
    } catch (error) {
        debugger
    }
}


//获取导入空间配置
export function uploadCfg(url, {
    onUploading = ({
        file,
        fileList,
        event
    }) => {
        //console.log(file, fileList);
    },
    onDone = ({
        file,
        fileList,
        event
    }) => {
        const {
            response,
            name
        } = file
        // const res = file.response;
        const {
            retCode,
            retMsg,
            retData
        } = response;
        if (retCode &&
            retCode === 200) {
            onUploadSuccess(retData);
            message.info(retMsg, 10);
        } else if (retCode &&
            Number(retCode) === 999) {
            onUploadFail(response)
            message.error(`${name} 上传失败, Token过期，请退出系统，重新登陆！`, 10);
        } else {
            onUploadFail(response)
            message.error(`${name} 上传失败,返回码-${retCode},返回信息-${retMsg}`, 10);
        }
    },
    onError = ({
        file = {},
        fileList,
        event
    }) => {
        const {
            response = {}
        } = file;
        const {
            retCode = null, retMsg = null
        } = response;
        if (retMsg) {
            message.error(`${file.name} 上传失败,返回码-${retCode},返回信息-${retMsg}`, 10);
        } else {
            message.error(`${file.name} 上传失败.`);
        }

    },
    onUploadSuccess = (retData) => {
        // console.log("上传成功...!")
    },
    onUploadFail = (ret) => {

    },
    ...config
}) {
    if (!!!url) {
        message.error("上传地址为空!");
        return;
    }

    let cfg = {
        action: getBaseRequestUrl() + url,
        name: "file",
        headers: {
            authorization: getToken()
        },
        method: "POST",
        multiple: false,
        showUploadList: false,
        directory: false,
        data: {},
        onChange(info) {
            if (info.file.status !== 'uploading') {
                onUploading(info);
            }
            if (info.file.status === 'done') {
                onDone(info)
            } else if (info.file.status === 'error') {
                // console.log(info)
                onError(info)
            }
        },
    }

    return !!config ? {
        ...cfg,
        ...config
    } : cfg;
}